import { SELECTION_OUTLINE_COLOR } from "./selectionOutlinePass.ts";

/** Default helper/object-guide line color for deselected empties and curves. */
export const OBJECT_HELPER_COLOR = "#000000";

/** Hover highlight for helper objects that don't participate in the outline pass. */
export const OBJECT_HELPER_HOVER_COLOR = "#ffffff";

/**
 * Curves and empties don't have a surface outline in their deselected state,
 * so their helper lines need an explicit neutral base color instead of the
 * selection accent.
 */
export function getCurveHelperColor(
  selected: boolean,
  showSelectionState: boolean,
): string {
  return selected && showSelectionState
    ? SELECTION_OUTLINE_COLOR
    : OBJECT_HELPER_COLOR;
}

/**
 * Empties use the same selected accent as other objects, but keep a white
 * hover state during eyedropper sessions so the hovered target stays obvious.
 */
export function getEmptyHelperColor(
  selected: boolean,
  eyedropperHovered: boolean,
): string {
  if (eyedropperHovered) return OBJECT_HELPER_HOVER_COLOR;
  return selected ? SELECTION_OUTLINE_COLOR : OBJECT_HELPER_COLOR;
}

/**
 * Wire-only mesh objects use the same neutral helper base as curves so free-
 * standing segments don't read as preselected.
 */
export function getWireObjectColor({
  selected,
  showSelectionState,
}: {
  selected: boolean;
  showSelectionState: boolean;
}): string {
  return getCurveHelperColor(selected, showSelectionState);
}
